import { type ZodType, z } from "zod";

type NonNegativeIntegerMessages = {
	integerMessage: string;
	maxMessage: string;
};

export const optionalNonNegativeInteger = (
	max: number,
	messages: NonNegativeIntegerMessages,
): ZodType<number | null, z.ZodTypeDef, number | null | undefined> =>
	z
		.number()
		.int(messages.integerMessage)
		.min(0, messages.integerMessage)
		.max(max, messages.maxMessage)
		.nullish()
		.transform((val) => val ?? null);
